<template>
  <div class="game-info-area board__header container-fluid ">
    <div class="row">
      <!-- <button v-on:click="initCards" type="button" class="btn btn-danger col-2 btn-new-game">New Game</button> -->
      <div class="col-3">{{ roomName }}</div>
      <score v-bind:score="score"></score>
      <div class="col-3">
        <!-- <button v-on:click="initCards" type="button" class="btn btn-danger btn-new-game">New Game</button>
        <font-awesome-icon icon="cog" size="1x"></font-awesome-icon> -->
      </div>
      <!-- <info label="Time:" v-bind:text="time"></info> -->
      <!-- <info v-bind:label="info.label" v-bind:text="info.text"></info> -->
    </div>
  </div>
</template>

<script>
import Score from './Score/Score.vue'
// import Info from './Info/Info.vue'
export default {
  props:["score", "roomName", "view"],
  components: {
    'score': Score,
    // 'info' : Info
  },
  data() {
    return {}
  }
}
</script>
<style lang="stylus">
@require '../../../styles/index'
.game-info-area
  text-align: center
  margin-bottom 20px
  box-sizing border-box
  box-shadow 0px 4px 4px rgba(0, 0, 0, 0.5)
  border-radius 30px
  font-size 30px
  font-weight bold
  background $color__background-board-top--default
  .dark-theme &
    background $color__background-board-top--dark-theme
  &__label
    font-size 30px
</style>
